// eslint-disable-next-line jira/restricted/react-lazy
import React, { lazy } from 'react';
// eslint-disable-next-line import/order
import { LazySuspense } from '@atlassian/react-loosely-lazy';

import { ModalTransition } from '@atlaskit/modal-dialog';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { Props } from '@atlassian/jira-software-add-comment-on-flag-action/src/ui/types.tsx';

const FlagWithComment = lazy(
	() =>
		import(
			/* webpackChunkName: "async-add-comment-on-flag-action" */ '@atlassian/jira-software-add-comment-on-flag-action/src/ui/index.tsx'
		),
);

export const FlagWithCommentRenderer = (props: Props) => (
	<JSErrorBoundary
		id="backlog-flag-with-comment-modal"
		packageName="jira-software-backlog"
		teamName="a4t-tanuki"
		fallback="flag"
	>
		<LazySuspense fallback={null}>
			<ModalTransition>
				<FlagWithComment {...props} />
			</ModalTransition>
		</LazySuspense>
	</JSErrorBoundary>
);
